import React, { useState } from "react";
import { CButton, CForm, CFormInput, CFormLabel } from "@coreui/react-pro";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import userServices from "../../services/user";

function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [form, setForm] = useState({ password: "", confirmPassword: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit() {
    setError("");
    setIsLoading(true);
    const res = await userServices.resetPassword({ token, ...form });
    setIsLoading(false);

    if (!res.success) {
      setError(res.message);
      return;
    }

    navigate("/login?redefinido=1");
  }

  return (
    <div id="login-blog">
      <div className="align">
        <div className="img">
          <span style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, color: "#fff", fontSize: "2rem", textAlign: "center", display: "block" }}>
            Cartório Nova Veneza
          </span>
          <div className="identifier">
            <p>
              Cartório Nova Veneza © 2026 | A Software develop by{" "}
              <a href="https://singlec.com.br/" target="_blank" rel="noreferrer">
                Singlec
              </a>
            </p>
          </div>
        </div>

        <CForm>
          <div>
            <h1 className="mb-2">Redefinir senha</h1>
            <p className="mb-4">
              Crie uma nova senha para sua conta.
            </p>
            <div className="align-form">
              {!token ? (
                <>
                  <p className="forgot-message">Link inválido ou expirado.</p>
                  <Link to="/login" className="forgot-link">Solicitar novo link</Link>
                </>
              ) : (
                <>
                  <div>
                    <CFormLabel>Nova senha:</CFormLabel>
                    <CFormInput
                      type="password"
                      value={form.password}
                      onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
                    />
                  </div>
                  <div>
                    <CFormLabel className="mt-4">Confirmar nova senha:</CFormLabel>
                    <CFormInput
                      type="password"
                      value={form.confirmPassword}
                      onChange={(e) => setForm((p) => ({ ...p, confirmPassword: e.target.value }))}
                    />
                  </div>
                  {error && (
                    <div className="mt-3">
                      <p className="forgot-message">{error}</p>
                      <Link to="/login" className="forgot-link">Solicitar novo link</Link>
                    </div>
                  )}
                  <CButton className="mt-4" type="button" disabled={isLoading} onClick={handleSubmit}>
                    {isLoading ? "Salvando..." : "Redefinir senha"}
                  </CButton>
                </>
              )}
            </div>
          </div>
        </CForm>
      </div>
    </div>
  );
}

export default RedefinirSenha;
